import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const Edit = ({ size = 14, title = 'Edit', fill = colors.silverSand }: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 30.17 30.21">
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M19,.35.5,18.83a1.31,1.31,0,0,0-.36.82L0,29.06a1.16,
1.16,0,0,0,.36.84,1.19,1.19,0,0,0,.84.31h0l9.14-.07a1.17,
1.17,0,0,0,.83-.32L29.83,11.17a1.21,1.21,0,0,0,
0-1.69L20.68.33A1.25,1.25,0,0,0,19,.35ZM9.83,27.8l-7.43.09.12-7.72L14.87,
7.83l7.46,7.46ZM24,13.63,16.56,6.16l3.28-3.28,7.44,7.46Z
`}
        fill={fill}
      />
    </svg>
  );
};
